import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import SaleReconciliationReport from './SaleReconciliationReport';
import InvestorReconciliationReport from './InvestorReconciliationReport';

ReconciliationReport.propTypes = {};

function ReconciliationReport(props) {
    return (
        <div>
            <div className="container-fluid px-0">
                <Routes>
                    <Route path="sale/*" element={<SaleReconciliationReport />} />
                    <Route path="investor/*" element={<InvestorReconciliationReport />} />
                    {/* <Route path="group" element={<GroupDashboardScreen />} />
                    <Route path="landlord" element={<LandlordDashboardScreen />} /> */}
                    <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
                </Routes>
            </div>
        </div>
    );
}

export default ReconciliationReport;
